import React, { useEffect, useState } from "react";
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import ts1 from '../../images/testimonials/img-1.jpg'
import ts2 from '../../images/testimonials/img-2.jpg'
import CountUp from 'react-countup';
import { getReports } from '../../api/sanity';

function getReportTotal(report) {
    return (
        (report.produce || 0) +
        (report.meat || 0) +
        (report.dairy || 0) +
        (report.grocerySelfStable || 0) +
        (report.baked || 0) +
        (report.prepared || 0) +
        (report.riceAndBeans || 0) +
        (report.gleanersProduce || 0)
    );
}

const Testimonial = (props) => {

    const [totalDonated, setTotalDonated] = useState(0);

    useEffect(() => {
        getReports()
            .then((reports) => {
                const total = reports.reduce(
                    (sum, report) => sum + getReportTotal(report),
                    0
                );
                setTotalDonated(total);
            })
            .catch((error) => {
                console.error("Error fetching donation total:", error);
            });
    }, []);

    const testimonial = [
        {
            tsImg: ts1,
            Des: "Recently cut out of an illustrated magazine and housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer",
            Title: 'Michel Jone',
            Sub: "Creative Designer",
        },
        {
            tsImg: ts2,
            Des: "Recently cut out of an illustrated magazine and housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer",
            Title: 'Aliza Anney',
            Sub: "Model Belarus",
        },
        {
            tsImg: ts1,
            Des: "Recently cut out of an illustrated magazine and housed in a nice, gilded frame. It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer",
            Title: 'David Miller',
            Sub: "Designer UK",
        }
    ]

    const funFact = [
        {
            title: '25',
            subTitle: 'Volunteers',
            Symbol: '+',
        },
        {
            title: '2500',
            subTitle: 'Happy Children',
            Symbol: '+',
        },
        {
            title: totalDonated,
            subTitle: 'Lbs Donated',
            Symbol: '+',
        },
        {
            title: '2515',
            subTitle: 'Campaigns',
            Symbol: '+',
        },
    ]

    return (

        <section className="testimoninals-funfact-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-xl-8 col-lg-7 col-12">
                        <div className="section-title">
                            <span>#Testimonials</span>
                            <h2>Client Feedback</h2>
                        </div>
                        <div className="testimonials-slider testimonials-slider-area">
                            <Swiper
                                modules={[Navigation, A11y]}
                                spaceBetween={0}
                                slidesPerView={1}
                                navigation
                                speed={1000}
                                loop={true}
                            >
                                {testimonial.map((tesmnl, tsm) => (
                                    <SwiperSlide key={tsm}>
                                        <div className="grid">
                                            <div className="author">
                                                <div className="author-img">
                                                    <img src={tesmnl.tsImg} alt="" />
                                                </div>
                                                <h5>{tesmnl.Title}</h5>
                                                <span>{tesmnl.Sub}</span>
                                            </div>
                                            <p>{tesmnl.Des}</p>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                    <div className="col col-xl-4 col-lg-5 col-12">
                        <div className="fun-fact-area">
                            <div className="fun-fact-grids clearfix">
                                {funFact.map((funfact, fitem) => (
                                    <div className="grid" key={fitem}>
                                        <div className="info">
                                            <div>
                                                <h3><span><CountUp end={funfact.title} enableScrollSpy /></span>{funfact.Symbol}</h3>
                                            </div>
                                            <div>
                                                <p>{funfact.subTitle}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;